import Body from '@ausbom/body/lib/Body';
import Typography from '@ausbom/typography/lib/Typography';
import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';
import AppHero from '../../components/AppHero/AppHero';
import Page from '../../components/Page/Page';

export const Route = createFileRoute('/past-market-information/$zone')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <PageWrapper title="Past market information" description="Download data for a trading zone">
      <AppHero title="Past market information" isoBars={2} />
      <Page>
        <Body>
          <Typography as="h2" styleName="heading-m" isResponsive>
            Download data for a trading zone
          </Typography>
        </Body>
      </Page>
    </PageWrapper>
  );
}
